const Calendar2Icon = (props) => {
    return (
        <svg
          width={25}
          height={25}
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g clipPath="url(#clip0_100_168)">
            <path
              d="M3.125 3.906V.781a.78.78 0 111.563 0v3.125a.78.78 0 11-1.563 0zm13.282.782a.78.78 0 00.78-.782V.781a.78.78 0 10-1.562 0v3.125c0 .432.35.782.782.782zM25 18.75a6.25 6.25 0 11-12.5 0 6.25 6.25 0 0112.5 0zm-1.562 0a4.693 4.693 0 00-4.688-4.688 4.693 4.693 0 00-4.687 4.688 4.693 4.693 0 004.687 4.688 4.693 4.693 0 004.688-4.688zM6.25 9.375H3.125V12.5H6.25V9.375zm-3.125 7.813H6.25v-3.126H3.125v3.126zM7.813 12.5h3.125V9.375H7.813V12.5zm0 4.688h3.125v-3.126H7.813v3.126zm-6.25 1.407V7.812H18.75v3.125h1.563V4.843c0-.949-.757-1.718-1.692-1.718h-.652v.781c0 .86-.7 1.563-1.562 1.563a1.565 1.565 0 01-1.563-1.563v-.781H5.47v.781c0 .86-.7 1.563-1.562 1.563a1.565 1.565 0 01-1.563-1.563v-.781h-.65C.757 3.125 0 3.895 0 4.843v13.752c0 .946.758 1.718 1.693 1.718h9.245V18.75H1.693c-.07 0-.13-.073-.13-.155zM15.625 12.5V9.375H12.5V12.5h3.125zm5.469 6.25H18.75v-2.344a.78.78 0 10-1.562 0v3.125c0 .432.349.782.78.782h3.126a.78.78 0 100-1.563z"
              fill="#5E5E5E"
            />
          </g>
          <defs>
            <clipPath id="clip0_100_168">
              <path fill="#fff" d="M0 0H25V25H0z" />
            </clipPath>
          </defs>
        </svg>
      )
}

export default Calendar2Icon